<template>
	<el-drawer title="订单预报" :visible.sync="drawer" direction="rtl" :modal="false" :append-to-body="true">
        <el-form ref="form" :model="voucher" label-width="70px" style="margin: 0px 10px;">
			<el-form-item label="客户单号" :class="(!voucher.wayBillNo || voucher.wayBillNo.length < 5)?'redItem':''" style="margin-bottom: 0px;margin-right: 10px;" ref="wayBillNo">
				<el-input ref="wayBillNoInput" v-model="voucher.wayBillNo" @input="wayBillNoInput" @change="wayBillNoChanged" placeholder="不录入提交时会自动生成一个单号"></el-input>
			</el-form-item>
			<el-form-item label="预报渠道" style="margin-bottom: 0px;margin-right: 10px;" ref="wayBillNo">
				<el-select v-model="voucher.quoteCode" filterable placeholder="请选择渠道" clearable @keyup.enter.native='keyupEnter("quoteCode")' style="width: 100%;" @change="quoteChange">
					<el-option v-for="(item,index) in quoteList" :key="index" :label="item.providerQuoteName" :value="item.providerQuoteCode">
					</el-option>
				</el-select>
			</el-form-item>
            <el-row>
                <el-col :span="9">
                    <el-form-item label="件数" style="margin-bottom: 0;width: 100%;" ref="pieces">
                        <el-input v-model="voucher.pieces" style="width: 100%;"></el-input>
                    </el-form-item>					
				</el-col>
				<el-col :span="9">
                    <el-form-item label="重量" style="margin-bottom: 0;" ref="settlementWeight">
                        <el-input v-model="voucher.settlementWeight"></el-input>
                    </el-form-item>					
				</el-col>
                <el-col :span="6" style="display: flex;justify-content:flex-end;">
                    <el-button type="text" size="mini" style="width: 80%; color: blue;" v-if="voucher.voucherSizes.length==0 && voucher.goodsType == 1" @click="openForecastSizeDialog">录尺寸</el-button>                    
                    <el-button type="text" size="mini" style="width: 80%; color: blue;" v-if="voucher.voucherSizes.length>0 && voucher.goodsType == 1" @click="openForecastSizeDialog">尺寸明细【{{voucher.voucherSizes.length}}】</el-button>                                        
                </el-col>				
			</el-row>
            <el-row>
                <el-col :span="9">
                    <el-form-item label="货物类型" style="margin-bottom: 0;" ref="goodsType">
                        <el-select v-model="voucher.goodsType">
                            <el-option label="包裹" :value="1"></el-option>
                            <el-option label="文件" :value="2"></el-option>
                            <el-option label="PAK袋" :value="3"></el-option>
                        </el-select>
                    </el-form-item>			
				</el-col>
				<el-col :span="9">
					<el-form-item label="电池" style="margin-bottom: 0; width: 100%;">
					    <el-select v-model="voucher.batteryName">
					        <el-option v-for="item in batteryNameOptions" :label="item" :value="item" :key="item"></el-option>
					    </el-select>
					</el-form-item>			
				</el-col>
				<el-col :span="6" style="height: 30px; display: flex; justify-content: center; align-items: center;">
					<el-checkbox v-model="voucher.gateDeclared" true-label="单独报关" false-label="不报关">单独报关</el-checkbox>
				</el-col>
			</el-row>
			<el-divider></el-divider>						
            <el-form-item label="收件公司" :class="(!voucher.receiverCompany) || (voucher.receiverCompany.length <= 2 || voucher.receiverCompany.length>35)?'redItem':''" style="margin-bottom: 0px;" ref="receiverCompany">
                    <el-input id="receiverCompanyInput" v-model="voucher.receiverCompany" maxlength="100" show-word-limit 
                        @focus="focusFormItem('收件公司')"
                        @input="forceUpdate"               
                        @change="receiverRecognize('company')"
                        @blur="voucher.receiverCompany=formatValue(voucher.receiverCompany)"
                        ></el-input>
            </el-form-item>            
            <el-form-item label="收件人" :class="(!voucher.receiver) || (voucher.receiver.length<=2 || voucher.receiver.length>35)?'redItem':''" style="margin-bottom: 0px;" ref="receiver">
                <el-input v-model="voucher.receiver" maxlength="100" show-word-limit 
                    @focus="focusFormItem('收件人')"
                    @input="forceUpdate"
                    @change="receiverRecognize('receiver')"                    
                    @blur="voucher.receiver=formatValue(voucher.receiver)"></el-input>            
            </el-form-item>      	
            <el-form-item label="电话" :class="(!voucher.receiverPhone) || (voucher.receiverPhone.length<=2 || voucher.receiverPhone.length>35)?'redItem':''" style="margin-bottom: 0px;" ref="receiverPhone">
				<el-input v-model="voucher.receiverPhone" maxlength="100" show-word-limit   
                    @focus="focusFormItem('电话')"
                    @input="forceUpdate"
                    @change="receiverRecognize('phone')"                     
                    @blur="receiverPhoneBlur"></el-input>					                    
            </el-form-item>    	
            <el-row>
                <el-col :span="20">
                    <el-form-item label="地址" :class="(!receiverAddress) || (receiverAddress.length<=2 || receiverAddress.length>105)?'redItem':''" style="margin-bottom: 0px;" ref="receiverAddress">
                        <el-input type="textarea" rows="3" placeholder="请输入收件人地址" maxlength="300" show-word-limit
                                    v-model="receiverAddress" 
                                    @focus="focusFormItem('地址')"  
                                    @change="receiverRecognize('address')">
                        </el-input>		                        
                    </el-form-item>	                    
                </el-col>
                <el-col :span="4"  style="height: 60px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <el-input v-model="charsPerLine" type="number" @blur="charsPerLineBlur"></el-input>
                    <span style="color: #409EFF;font-size:14px;font-weight: bold;">/行</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14">
                    <el-form-item label="国家" :class="(!voucher.receiverCountryName)?'redItem':''" style="margin-bottom: 0;" ref="receiverCountryCode">
                          <el-select v-model="voucher.receiverCountryCode" clearable filterable default-first-option remote :remote-method="filterCountry" 
                            placeholder="请选择目的地" @change="receiverCountryCodeChanged" @clear="clearReceiverCountryCode"
                            @input="forceUpdate"
                            >
                            <el-option v-for="(item,i) in countryOptionsCrror" :key="i" :label="item.nameChinese" :value="item.countryCode">{{item.countryCode}}<el-divider direction="vertical"></el-divider>{{item.nameChinese}}<el-divider direction="vertical"></el-divider>{{item.nameEnglish}}</el-option>
                          </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="州" style="margin-bottom: 0;" ref="receiverStateName">
                        <el-select v-if="voucher.receiverCountryCode && voucher.receiverCountryCode =='US'" v-model="voucher.receiverStateCode" filterable default-first-option 
                            remote :remote-method="remoteMethodCountryState" @change="changeCountryState(countryStateOptions,$event)" clearable
                             @clear="clearReceiverStateName"
                             >
                            <el-option :label="countryState.nameChinese" :value="i" v-for="(countryState,i) in countryStateOptions" :key="i">
                                {{countryState.stateCode}}<el-divider direction="vertical"></el-divider>{{countryState.nameEnglish}}<el-divider direction="vertical"></el-divider>{{countryState.nameChinese}}
                            </el-option>
                        </el-select>
                        <el-input v-else v-model="voucher.receiverStateCode" @input="forceUpdate"></el-input>
                    </el-form-item>
                </el-col>                            
            </el-row>
            <el-row>
                <el-col :span="18">
                    <el-form-item label="邮编" style="margin-bottom: 0;" ref="receiverPostCode">
                        <el-autocomplete
                          class="inline-input"
                          v-model="voucher.receiverPostCode"
                          :disabled="!voucher.receiverCountryCode"
                          :fetch-suggestions="remoteMethodReceiverPostCode"
                          :placeholder="!voucher.receiverCountryCode?'目的地未选择':'请选择邮编'"
                          clearable                             
                          @select="changeReceiverPostCodeCityName"
                          @clear="clearReceiverPostCodeCityName"
                          @input="forceUpdate"
                          @blur="receiverPostCodeCityNameBlur"
                        >
                            <template slot-scope="{item}">
                                <span>{{item.cityInfo}}</span>
                            </template>
                        </el-autocomplete>                
                    </el-form-item>
                </el-col>
                <el-col :span="6" style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
                    <el-button type="text" style="color:#3975C6;" :disabled="!receiverAddress || !voucher.receiverCountryCode" @click="btnRecognizeAddressClick">识别城市</el-button>
                    <el-dropdown  @command="queryCityCommand" style="margin-left: 20x;" trigger="click">
                      <span class="el-dropdown-link">
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item style="width: 100px;" command="ADDR">美国地址查询</el-dropdown-item>
                        <el-dropdown-item command="DHL">查DHL城市</el-dropdown-item>                        
                        <el-dropdown-item command="UPS">查UPS城市</el-dropdown-item>
                        <el-dropdown-item command="FEDEX">查FEDEX城市</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>                      
                </el-col>
            </el-row>
			<el-row>
				<el-col :span="18">
					<el-form-item label="城市" style="margin-bottom: 0; width: 100%;" :class="(!voucher.receiverCityName) || voucher.receiverCityName.length<=2 || (receiverAddress.toUpperCase().indexOf(voucher.receiverCityName.toUpperCase()) < 0)?'redItem':''" ref="receiverCityName"> 
						<el-autocomplete
						  class="inline-input"
						  v-model="voucher.receiverCityName"
						  :disabled="!voucher.receiverCountryCode"
						  :fetch-suggestions="remoteMethodReceiverCityName"
						  :placeholder="!voucher.receiverCountryCode?'目的地未选择':'请选择城市'"
						  clearable
						  @select="changeReceiverPostCodeCityName"
						  @clear="clearReceiverPostCodeCityName"
						  @input="forceUpdate"
						  @blur="receiverPostCodeCityNameBlur"
						>
							<template slot-scope="{item}">
								<span>{{item.cityInfo}}</span>
							</template>
						</el-autocomplete>                                        
					</el-form-item>  
				</el-col>
				<el-col :span="6" style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
					<div v-if="voucher.receiverHubCode" style="font-size: 14px;">机场:{{voucher.receiverHubCode}}</div>
				</el-col>
			</el-row>
            <el-row>
                <el-col :span="14">
                    <el-form-item label="税号" style="margin-bottom: 0;" ref="receiverVatNo">
						<el-input v-model="voucher.receiverVatNo" @input="forceUpdate"></el-input>					
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="邮箱" style="margin-bottom: 0;" ref="receiverEmail">
                        <el-input v-model="voucher.receiverEmail" @input="forceUpdate"></el-input>
                    </el-form-item>
                </el-col>                            
            </el-row>			
            <el-form-item style="margin-bottom: 0;">
                <div style="color: red;">{{receiverRemoteInfo}}</div>
            </el-form-item>
            <el-form-item style="margin-bottom: 0;">
                <div style="color: red;">{{receiverCountryRemark}}</div>
            </el-form-item>
            <el-form-item style="margin-bottom: 0;">
                <div style="color: red;">{{receiverPhoneInfo}}</div>
            </el-form-item>  
			<el-divider></el-divider>				
			<goodsReport :goodsReport="currentDetailRow" :unrulyGoodsList="unrulyGoodsList" :recoSetting="goodsRecoSetting" 
					@formCancel="goodsReportFormCancel" @formSave="goodsReportFormSave" @formSaveAs="goodsReportFormSaveAs"  
					@unrulyGoodsSetting="unrulyGoodsSetting" ref="goodsReportForm">
			</goodsReport>
			<el-table ref="detailTable"
				:data="voucher.voucherDetails" 
				highlight-current-row
				:show-header="false"
				empty-text="产品申报"
				:cell-class-name="sizeTableCellClassName"
				@current-change="detailTableCurrentChanged"
				>
				<el-table-column prop="desc" label="描述" min-width="80%">
					<template slot-scope="scope">
						<span v-if="!checkDetailRow(scope.row)" style="color:red;font-size: 16px;"><i class="el-icon-warning"></i></span>
						<span style="color:#3975C6;margin-left: 5px;">{{scope.row.goodNameEnglish}}</span>
						<span style="color:#3975C6;margin-left: 5px;">{{scope.row.goodNameChinese}}</span>
						<span style="color:#3975C6;margin-left: 5px;">{{scope.row.number}}</span>
						<span style="color:#3975C6;margin-left: 5px;">{{scope.row.unit}}</span>       
						<span style="color:#3975C6;margin-left: 5px;">{{'价值:' + scope.row.totalPrice}}</span> 				 
					</template>
				</el-table-column>
				<el-table-column
				  fixed="right"
				  label="操作"
				   min-width="10%">
				  <template slot-scope="scope">
					<el-button type="text" size="small" @click.native.prevent="removeDetail(scope.$index, voucher.voucherDetails)">
					  移除
					</el-button>
				  </template>
				</el-table-column>                
			</el-table>
			<div style="height: 6px;"></div>
            <el-row>
                <el-col :span="14">
                    <el-form-item label="币种" style="margin-bottom: 0; width: 100%;">
                        <el-select v-model="voucher.currencyType" clearable>
                            <el-option v-for="item in currencyTypeOptions" :label="item" :value="item" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="总价" :class="(Math.round(voucher.totalPrice * 100)!= Math.round(totalPrice*100))?'redItem':''" style="margin-bottom: 0;width: 100%;">
                        <el-input v-model="voucher.totalPrice" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>                            
            </el-row>			
			<div style="display: flex; flex-direction: row; align-items:center; justify-content: flex-end; margin-top: 10px;">
				<el-button type="primary" style="width: 100px;" @click="saveVoucher">提交</el-button>
			</div>				
		</el-form>	
        <el-dialog :visible.sync="unrulyGoodsDialogVisible" width="90%" :show-close="true" @close="unrulyGoodsDialogClose" :modal="false">
            <el-tabs type="border-card" v-model="goodsSettingActiveTab" style="margin-top: 5px;">
                <el-tab-pane label="不合规品名" name="unrulyGoods">
                    <unruly-goods></unruly-goods>
                </el-tab-pane>
                <el-tab-pane label="产品信息识别" name="goodsReco">
                    <goods-reco :setting="goodsRecoSetting" ref="goodsRecoForm"></goods-reco>
                </el-tab-pane>
                <el-tab-pane label="收件信息" name="receiverReco">
                    <receiver-reco :setting="receiverRecoSetting" ref="receiverRecoForm"></receiver-reco>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
		<el-dialog title="地址验证" :visible.sync="validateAddressDialogVisible" width="50%" :modal="false">
			<div style="margin: 0px 10px;">
				<div style="display: flex; flex-direction: row;">
					<el-input type="textarea" rows="3" placeholder="请输入收件人地址" maxlength="300" show-word-limit v-model="receiverAddress" style="flex: 1;">
					</el-input>	
					<el-button type="primary" @click="validateAddressDialogQuery">查询</el-button>
				</div>
				<div style="display: flex; flex-direction: row; align-items: center; height: 40px; font-size: 16px;">
					<span>查询结果</span>
					<span style="margin-left: 10px;color: red;">{{validateAddressResult}}</span>
				</div>
				<div v-html="validateAddressResultAddress" style="color=#6b6b6b; font-size: 16px;"></div>
			</div>
            <span slot="footer" style="display: flex; flex-direction: row; justify-content: flex-end;">
                <el-button type="primary" @click="openUSMap">打开地图</el-button>
            </span> 			
		</el-dialog>				
		<forecastSize ref="forecastSizeDialog" :voucher="voucher" :netQuote="netQuote" :packageTypeOptions="packageTypeOptions" @close="forecastSizeDialogClose"></forecastSize>
	</el-drawer>
</template>

<script>
	import goodsReport from './goods-report'
	import unrulyGoods from './unruly-goods.vue'
	import goodsReco from './goods-reco.vue'	
	import forecastSize from './forecast-size.vue'
	import * as string from '@/utils/string'	
	export default{
		components: {
			goodsReport,
			unrulyGoods,
			goodsReco,
			forecastSize
		},	
		props: {
			quoteList: {
				type: Array,
				default: () => []
			},
			countryOptions: {
				type: Array,
				default: () => []
			},
			branchList: {
				type: Array,
				default: () =>[]
			}
		},		
		watch: {
			countryOptions(newVal, oldVal){
				this.countryOptionsCrror = newVal
			}
		},
		mounted(){
			this.voucher = this.voucher0()
			this.getPackageTypeOptions()
		},		
		data() {
			return {
				drawer: false,
				voucher: {
					id: 0,
					wayBillNo: '',
					voucherSizes:[],
					voucherDetails:[],
					goodsType: 1,
					batteryName: '无电',
					gateDeclared: '不报关',
					currencyType: 'USD',
					status: 0
				},
				netQuote: null,
				batteryNameOptions: [
					'无电',
					'PI967多电',
					'PI967少电',
					'PI970多电',
					'PI970少电',
					'PI966',
					'PI965'
				],
				currencyTypeOptions: [
					'USD',
					'EUR',
					'AUD'
				],				
				goodsRecoSetting:{
					goodNameEnglish:'品名:',
					goodNameChinese:'',
					materialEnglish:'material:,材质:',
					purposeEnglish:'used for:,purpose:,USR:,用途:',
					hsGoodCode: 'HS:,HS CODE:,海关编码:',
					materialChinese:'材质:',
					purposeChinese:'用途:'                
				},
				receiverRecoSetting:{
					company: 'COMPANY:,Company name:,Company name(公司名): ',
					receiver: 'ATTN:,Contact:, Contact person:,Contact person(收件人):',
					phone: 'PHONE:',
					address: 'ADDRE:,ADD:,Address:,Add(地址)'
				},
				receiverRecoPop:{
					company: false,
					phone: false,
					address: false,
					receiver: false
				},
				goodsSettingActiveTab: 'unrulyGoods',    				
				unrulyGoodsList: [],
				unrulyGoodsDialogVisible: false,
			    wayBillNoChecked: false,
				receiverAddress: '',
				receiverRemoteInfo: '',
				receiverPhoneInfo: '',
				receiverCountryRemark: '',  
				voucherWayBillInfo: '',
				currentDetailRow: null,
				skipSetCurrent: false,
				totalPrice: 0,
				charsPerLine: 35,
				countryOptionsCrror:[],
				countryStates:[],
				countryStateOptions:[],				
				packageTypeOptions:[],
				validateAddressResult: '',
				validateAddressResultAddress: '',				
				validateAddressDialogVisible: false,				
			}
		},
		mounted() {		
			this.getUnrulyGoodsList()
			this.getPackageTypeOptions()
		},
		methods:{
			open(param){
				this.wayBillNoChanged(param)
				if(typeof(param) === 'string'){
					this.voucher = this.voucher0()		
					this.voucher.wayBillNo = param
					this.wayBillNoChanged()
				}else
				if(typeof(param) === 'object'){
					this.wayBillNoChanged(param)
				}
				this.drawer = true
			},
			voucher0(){
				return {
					id: 0,
					wayBillNo: '',
					voucherSizes:[],
					voucherDetails:[],
					goodsType: 1,
					batteryName: '无电',
					gateDeclared: '不报关',
					currencyType: 'USD',
					status: 0
				}				
			},
			forceUpdate(){
				this.$forceUpdate()
			},
			sizeTableCellClassName({row, column, rowIndex, columnIndex}){
				  //注意这里是解构
				  //利用单元格的 className 的回调方法，给行列索引赋值
				  row.index=rowIndex;
				  column.index=columnIndex;
			},						
			formatValue(value){
				if(value){
					let result = value.trim()
					result = result.replace(/\-|&|\+/g, " ")
					return result
				}else{
					return ""
				}
			},	
			focusFormItem(name){
				if(window.chrome.webview){
					window.chrome.webview.postMessage('focus:' + name) 
				}
			},			
			async getUnrulyGoodsList(){
				//不合规产品列表
				this.unrulyGoodsList = await this.$api.getUnrulyGoods()
			},	
			async getPackageTypeOptions(){
				let options = await this.$api.appdict('packageType')
				this.packageTypeOptions = []
				for(let option of options){
					this.packageTypeOptions.push({
						label: option.value,
						value: parseInt(option.key)
					})
				}				
			},							
			unrulyGoodsSetting(){
				this.unrulyGoodsDialogVisible = true
			},
			wayBillNoInput(){
				this.wayBillNoChecked = false
				this.$forceUpdate()
			},
			async wayBillNoChanged(param){
				this.wayBillNoChecked = true
				this.receiverAddress = ''
				this.receiverRemoteInfo = ''
				this.receiverCountryRemark = ''  
				this.voucherWayBillInfo = ''
				this.currentDetailRow = null				
				if(typeof(param) === 'string'){
					let wayBillNo = param	
					if(!wayBillNo){
						this.voucher = this.voucher0()
						this.voucher.wayBillNo = param
						this.receiverAddress = ''
						this.currentDetailRow = null						
						return					
					}
					let voucher = await this.$api.getForecastOrder(localStorage.getItem("tenantId"), wayBillNo)
					if(voucher.id == 0){
						this.voucher = this.voucher0()
						this.voucher.wayBillNo = wayBillNo
						this.receiverAddress = ''
						this.currentDetailRow = null						
						return	
					}
					this.voucher = {...voucher}
				}else{
					this.voucher = {...param}
				}
				if(!('voucherDetails' in this.voucher)){
					this.voucher.voucherDetails = []            
				}
				if(!('voucherSizes' in this.voucher)){
					this.voucher.voucherSizes = []            
				}
				let addr = []
				if(this.voucher.receiverAddress1)addr.push(this.voucher.receiverAddress1)
				if(this.voucher.receiverAddress2)addr.push(this.voucher.receiverAddress2)
				if(this.voucher.receiverAddress3)addr.push(this.voucher.receiverAddress3)      
				if(this.voucher.receiverAddress4)addr.push(this.voucher.receiverAddress4)                    
				this.receiverAddress = addr.join('\n')		
				this.quoteChange()
			},
			quoteChange(){
				if(!this.voucher.quoteCode){
					this.netQuote = null
				}else
				if(this.quoteList && (this.quoteList.length > 0)){
					for(let quote of this.quoteList){
						if(quote.providerQuoteCode == this.voucher.quoteCode){
							this.netQuote = quote
							break
						}
					}
				}
			},
			checkReceiverRecoPrefix(content){
				let prefixArr = this.receiverRecoSetting.company?this.receiverRecoSetting.company.replace('：', ':').split(/,|，|\n/):[]
				prefixArr = prefixArr.concat(this.receiverRecoSetting.receiver?this.receiverRecoSetting.receiver.replace('：', ':').split(/,|，|\n/):[])
				prefixArr = prefixArr.concat(this.receiverRecoSetting.phone?this.receiverRecoSetting.phone.replace('：', ':').split(/,|，|\n/):[])
				prefixArr = prefixArr.concat(this.receiverRecoSetting.address?this.receiverRecoSetting.address.replace('：', ':').split(/,|，|\n/):[]) 
				for(let prefix of prefixArr){
					let keyword = prefix.trim()
					if(keyword){
						if(content.toUpperCase().indexOf(keyword.toUpperCase()) >=0){
							return true
						}
					}
				}
			},			
			receiverRecognize(fieldName){
				let content = ''
				if(fieldName == 'company')
					content = this.voucher.receiverCompany
				else
				if(fieldName == 'receiver')
					content = this.voucher.receiver
				else
				if(fieldName == 'phone')
					content = this.voucher.receiverPhone
				else{
					this.receiverAddress = this.formatValue(this.receiverAddress)
					content = this.receiverAddress
				}
				content = content.replace('：', ':')
				if(content.startsWith('"') && content.endsWith('"')){
					//从EXECEL黏贴过来，可能有引号
					content = content.substr(1, content.length - 2)
				}        
				let prefixArr = this.receiverRecoSetting[fieldName]?this.receiverRecoSetting[fieldName].split(','):[]
				if(prefixArr.length > 0){
					for(let prefix of prefixArr){
						prefix = prefix.replace('：', ':') //中文冒号替换为英文冒号
						if((prefix) && (content.toUpperCase().startsWith(prefix.toUpperCase()))){
							content = content.substr(prefix.length)
							break
						}
					}            
				}
				if(fieldName == 'company')
					this.voucher.receiverCompany = content
				else
				if(fieldName == 'receiver')
					this.voucher.receiver = content
				else
				if(fieldName == 'phone')
					this.voucher.receiverPhone = content
				else{
					this.receiverAddress = content
				}
				if(this.checkReceiverRecoPrefix(content)){
					this.$refs[fieldName + 'Reco'].parseContent(content)
					this.receiverRecoPop[fieldName] = true
				}else{
					if(fieldName == "address"){
						this.rebuildReceiverAddress(this.receiverAddress)               
					}
				}
			},	
			splitAddress(newAddr){
				let addr = []
				let arr = newAddr.split(/\s+|\n|,/)            
				let l = 0
				let st = arr[0]
				for(let i = 1; i < arr.length; i++){
					if(l < 3){
						let nst = st + ' ' + arr[i]
						if(nst.length > this.charsPerLine){
							let ch = nst.substr(this.charsPerLine, 1)
							if(string.isChinese(ch)){
								st = nst.substr(0, this.charsPerLine)
								addr.push(st.trim())
								st = nst.substr(this.charsPerLine)
							}else{
								addr.push(st.trim())
								st = arr[i]
							}
							l++
						}else{
							st = nst
						}
					}else{
						st = st + ' ' + arr[i]
					}
					if((i == (arr.length - 1)) && (st)){
						addr.push(st.trim())
					}            
				}
				return addr
			},			
			rebuildReceiverAddress(receiverAddress){
				let addr = this.splitAddress(receiverAddress);
				this.receiverAddress = addr.join('\n')
				for(let i = addr.length; i < 4; i++){
					addr.push('')
				}
				this.voucher.receiverAddress1 = addr[0]
				this.voucher.receiverAddress2 = addr[1]
				this.voucher.receiverAddress3 = addr[2]
				this.voucher.receiverAddress4 = addr[3]            
			},			
			clearReceiverCountryCode(){
				this.voucher.receiverCountryCode = ''
				this.voucher.receiverCountryName = ''
				this.voucher.receiverPostCode = ''
				this.voucher.receiverCityName = ''
				this.voucher.receiverStateCode = ''
				this.voucher.receiverStateName = ''
			}, 
			changeCountryState(countryStateOptions, i){
				console.log(countryStateOptions)
				console.log(i)
				this.voucher.receiverStateCode = countryStateOptions[i].stateCode
				this.voucher.receiverStateName = countryStateOptions[i].nameChinese 
				this.$forceUpdate()
			},			 
			clearReceiverStateName(){
				this.countryStateOptions = this.countryStates
				this.voucher.receiverStateCode = ''
				this.voucher.receiverStateName = ''
			},			
			// 收件人国家
			async receiverCountryCodeChanged(){
				if(this.voucher.receiverCountryCode){
					for(let country of this.countryOptions){
						if(country.countryCode == this.voucher.receiverCountryCode){
							this.voucher.receiverCountryName = country.nameChinese
							this.receiverPhoneBlur()  //检查电话
							break
						}
					}
				}
				this.countryStates = []
				this.countryStateOptions = []
				this.voucher.receiverPostCode = ''
				this.voucher.receiverCityName = ''
				this.voucher.receiverStateCode = ''
				this.voucher.receiverStateName = ''     
				if(!string.isEmpty(this.voucher.receiverCountryCode)){
					this.receiverCountryRemark = await this.$api.getCountryVoucherRemark(this.voucher.receiverCountryCode)
				}                   
				if((!string.isEmpty(this.voucher.receiverCountryCode)) && (this.voucher.receiverCountryCode == 'US')){
					this.countryStates = await this.$api.countryStateList('US')
					this.countryStateOptions = this.countryStates
				}
			},	
			remoteMethodCountryState(queryString){
				if(string.isEmpty(queryString)){
					this.countryStateOptions = this.countryStates
				}else{
					let st = queryString.toUpperCase()
					this.countryStateOptions = this.countryStates.filter((item)=>{
						return (item.stateCode.toUpperCase().indexOf(st) != -1) || (item.nameEnglish.toUpperCase().indexOf(st) != -1) || (item.nameChinese.toUpperCase().indexOf(st) != -1)
					})
				}
			},					 
			// 邮编
			async remoteMethodReceiverPostCode(postCode, cb) {
				let countrycityOptions = await this.$api.countrycitysearchpage({
				  countryCode: this.voucher.receiverCountryCode,
				  postCode,
				  pageNum: 1,
				  pageSize: 500
				})
				this.countrycityOptions = countrycityOptions.list
				// for(let option of this.countrycityOptions){
				//     option.value = option.postCode
				// }
				// this.voucher.receiverPostCode = postCode
				// console.log(this.voucher.receiverPostCode)
				if(arguments.length == 2){
					cb(this.countrycityOptions)
				}
			},
			// 城市
			async remoteMethodReceiverCityName(cityName, cb) {
				let countrycityOptions = await this.$api.countrycitysearchpage({
				  countryCode: this.voucher.receiverCountryCode,
				  cityName,
				  pageNum: 1,
				  pageSize: 500
				})
				this.countrycityOptions = countrycityOptions.list
				if(arguments.length == 2){
				  cb(this.countrycityOptions)
				}
			},    
			clearReceiverPostCodeCityName(){
				this.voucher.receiverPostCode = ''
				this.voucher.receiverCityName = ''
				this.voucher.receiverStateCode = ''
				this.voucher.receiverStateName = ''
			},
			// 同步邮编城市
			async changeReceiverPostCodeCityName(item) {
						console.log(item)
				this.voucher.receiverPostCode = item.postCode
				this.voucher.receiverCityName = item.cityName
				if(item.hubCode){
					let arr = item.hubCode.split(',')
					this.voucher.receiverHubCode = arr[arr.length - 1]
				}
				if((this.voucher.receiverCountryCode) && (this.voucher.receiverPostCode) && (this.voucher.receiverCountryCode == 'CA')){
					let stateCode = this.parseCanadaStateCode(this.voucher.receiverPostCode)
					this.voucher.receiverStateCode = stateCode
				}
				if(item.stateCode){
					let states = this.countryStates.filter(state=>{return state.stateCode == item.stateCode})
					if(states.length > 0){
						this.voucher.receiverStateCode = states[0].stateCode
						this.voucher.receiverStateName = states[0].nameChinese
					}
				}
			},
			async receiverPostCodeCityNameBlur(){
				if((this.voucher.receiverCountryCode=='AU') && (this.voucher.receiverPostCode)){
					if(this.voucher.receiverPostCode.startsWith('2')){
						this.voucher.receiverStateCode = 'NSW'
						this.voucher.receiverStateName = '新南威尔士州 (New South Wales)'
					}else
					if(this.voucher.receiverPostCode.startsWith('3')){
						this.voucher.receiverStateCode = 'VIC'
						this.voucher.receiverStateName = '维多利亚州 (Victoria)'
					}else
					if(this.voucher.receiverPostCode.startsWith('4')){
						this.voucher.receiverStateCode = 'QLD'
						this.voucher.receiverStateName = '昆士兰州 (Queensland)'
					}else
					if(this.voucher.receiverPostCode.startsWith('5')){
						this.voucher.receiverStateCode = 'SA'
						this.voucher.receiverStateName = '南澳大利亚州 (South Australia)'
					}else
					if(this.voucher.receiverPostCode.startsWith('6')){
						this.voucher.receiverStateCode = 'WA'
						this.voucher.receiverStateName = '西澳大利亚州 (Western Australia)'
					}else
					if(this.voucher.receiverPostCode.startsWith('7')){
						this.voucher.receiverStateCode = 'TAS'
						this.voucher.receiverStateName = '塔斯马尼亚州 (Tasmania)'
					}else
					if(this.voucher.receiverPostCode.startsWith('8')){
						this.voucher.receiverStateCode = 'ACT'
						this.voucher.receiverStateName = '澳大利亚首都领地 (Australian Capital Territory)'
					}else
					if(this.voucher.receiverPostCode.startsWith('9')){
						this.voucher.receiverStateCode = 'NT'
						this.voucher.receiverStateName = '北领地 (Northern Territory)'
					}
				}
				let remoteCountryCodes = ['OM','AO', 'CG', 'CD','CR', 'QA', 'LR', 'MU', 'MR', 'NP', 'LK', 'GT']  //阿曼，安哥拉，刚果,刚果民主共和国, 哥斯达黎加,卡塔尔,利比里亚,毛里求斯,毛里塔尼亚,尼泊尔,斯里兰卡,危地马拉	
				if((remoteCountryCodes.indexOf(this.voucher.receiverCountryCode) >= 0) && !this.voucher.receiverPostCode){
					if((this.netQuote != null) && this.netQuote.bizType && (this.netQuote.bizType.toUpperCase().indexOf('UPS') != -1)){
						this.receiverRemoteInfo = 'UPS请输入邮编验证偏远'
						return
					}
				}
				this.receiverRemoteInfo = ''
				let page = await this.$api.remoteList(this.voucher.receiverCountryCode, this.voucher.receiverPostCode, this.voucher.receiverCityName)
				if(page.list.length > 0){
					let groups = []
					for(let remote of page.list){
						if(groups.indexOf(remote.bizGroup) == -1){
							groups.push(remote.bizGroup)
						}
					}
					this.receiverRemoteInfo = '偏远：' + groups.join(',')         
				}             
			},
			parseCanadaStateCode(postCode){
				let stateTable = {
					V:'BC', 
					T:'AB', 
					S:'SK',
					R:'MB',
					K:'ON',
					L:'ON',
					M:'ON',
					N:'ON',
					P:'ON',
					G:'QC',
					H:'QC',
					J:'QC',
					E:'NB',
					B:'NS', 
					C:'PE', 
					A:'NL',
					Y:'YT',
					X:'NT'
				}
				let fch = postCode.substr(0, 1)
				let stateCode = stateTable[fch]
				if(typeof(stateCode) == 'undefined'){
					stateCode = ''
				}
				return stateCode
			},
			async queryCityCommand(value){
				if(value == 'ADDR'){
					this.validateAddressText = this.receiverAddress
					this.validateAddressResult = ''
					this.validateAddressResultAddress = ''
					this.validateAddressDialogVisible = true
				}else
				if(value == "DHL"){
					window.open('https://www.5idhl.com/#/createExpress/ServiceArea')
				}else
				if(value == "FEDEX"){
					window.open('https://www.fedex.com/zh-cn/online/rating.html#')
				}else
				if(value == "UPS"){
					window.open('https://wwwapps.ups.com/ctc/request?loc=zh_CN')
				}
			},			
			openUSMap(){
				window.open('https://www.samezip.com/street?')
			},
			async btnRecognizeAddressClick(){		
				if(this.receiverAddress){
					this.receiverRemoteInfo = ''
					if(this.voucher.receiverCountryCode == 'US'){
						//美国地址识别
						let validateAddressResult = await this.$api.validateAddress(this.voucher)
						if(validateAddressResult.code == 200){
							this.$set(this.voucher, 'receiverStateName', '');
							this.$set(this.voucher, 'receiverStateCode', '');                                               
							for(let state of this.countryStates){
								if(state.stateCode == validateAddressResult.state){
									this.$set(this.voucher, 'receiverStateName', state.nameChinese);
									this.$set(this.voucher, 'receiverStateCode', state.stateCode);                               
									this.$set(this.voucher, 'receiverPostCode', validateAddressResult.zipCode)
									this.$set(this.voucher, 'receiverCityName', validateAddressResult.cityName)							
									break
								}
							}
							let rdi = validateAddressResult.rdi
							if(rdi == 'Residential'){
								rdi = '住宅地址(Residential)'
							}else
							if(rdi == 'Commercial'){
								rdi = '商业地址(Commercial)';
							}
							this.receiverRemoteInfo = rdi + ' '
						}else{
							this.$message.error(validateAddressResult.errMsg);                    
						}
					}else{
						let address = this.receiverAddress
						if((this.voucher.receiverPostCode) && (this.receiverAddress.indexOf(this.voucher.receiverPostCode) < 0)){
							address = address + ' ' + this.voucher.receiverPostCode
						}
						let upAddress = this.receiverAddress.replace(/\s+|\r/g,"").toUpperCase()
						this.$set(this.voucher, 'receiverCityName', '');
						this.$set(this.voucher, 'receiverPostCode', '');              
						let list = await this.$api.countrycitySmartSearch(this.voucher.receiverCountryCode, address)    
						if(list.length > 0){
							this.$set(this.voucher, 'receiverCityName', list[0].cityName);
							this.$set(this.voucher, 'receiverPostCode', list[0].postCode);                
							let upCityName = list[0].cityName.replace(/\s+/g,"").toUpperCase()
							let postCode = list[0].postCode
							if(list[0].postCode){                    
								if((address.indexOf(postCode) >= 0) && (upAddress.indexOf(upCityName) >= 0)){                        
									//
								}else
								if(address.indexOf(postCode) >= 0){
									setTimeout(()=>{this.$set(this.voucher, 'receiverCityName', '');this.$forceUpdate()}, 1000)
								}else{
									setTimeout(()=>{this.$set(this.voucher, 'receiverPostCode', '');this.$forceUpdate()}, 1000)                        
								}
							}
						}
						// if(this.voucher.receiverCountryCode == 'US'){
						//     this.$set(this.voucher, 'receiverStateName', '');
						//     this.$set(this.voucher, 'receiverStateCode', '');                                               
						//     let addrArr = this.receiverAddress.toUpperCase().split(/\s+|\r/g)
						//     let codes = addrArr.filter((item)=>item.length==2) //可能包含州的两字编码
						//     for(let state of this.countryStates){
						//         let ename = state.nameEnglish.replace(/\s+/g,"").toUpperCase()
						//         if((upAddress.indexOf(ename) >= 0) || (codes.indexOf(state.stateCode) >= 0)){
						//             this.$set(this.voucher, 'receiverStateName', state.nameChinese);
						//             this.$set(this.voucher, 'receiverStateCode', state.stateCode);                               
						//             break
						//         }
						//     }
						// }
						if((this.voucher.receiverCountryCode) && (this.voucher.receiverPostCode) && (this.voucher.receiverCountryCode == 'CA')){
							let stateCode = this.parseCanadaStateCode(this.voucher.receiverPostCode)
							this.voucher.receiverStateCode = stateCode
						}	
					}
					this.$forceUpdate()
					let page = await this.$api.remoteList(this.voucher.receiverCountryCode, this.voucher.receiverPostCode, this.voucher.receiverCityName)
					if(page.list.length > 0){
						let groups = []
						for(let remote of page.list){
							if(groups.indexOf(remote.bizGroup) == -1){
								groups.push(remote.bizGroup)
							}
						}
						this.receiverRemoteInfo = this.receiverRemoteInfo + '偏远：' + groups.join(',')         
					}            
				}
			},								
			async receiverPhoneBlur(){
				this.voucher.receiverPhone = this.formatValue(this.voucher.receiverPhone)
				this.voucher.receiverPhone = this.voucher.receiverPhone.replace(/\s+/g, '')
				if((this.voucher.receiverPhone) && (this.voucher.receiverCountryName)){
					this.receiverPhoneInfo = ''
					this.voucher.receiverPhone = this.voucher.receiverPhone.trim()  
					const countries = ['美国','加拿大','墨西哥','澳大利亚','德国','英国','法国','印度','巴西','瑞士','意大利'];        
					if((this.voucher.receiverPhone.length < 10) && (countries.indexOf(this.voucher.receiverCountryName) != -1)){
						this.receiverPhoneInfo = this.voucher.receiverCountryName + '电话应10位以上!'
					}			
				}			
			},
			charsPerLineBlur(){
				if((!this.charsPerLine) || (this.charsPerLine < 30) || (this.charsPerLine > 60)){
					this.charsPerLine = 35
				}
				this.receiverAddressBlur()
			},
			receiverAddressBlur(){
				this.receiverAddress = this.formatValue(this.receiverAddress)
				let addr = this.splitAddress(this.receiverAddress); 
				this.receiverAddress = addr.join('\n')
				for(let i = addr.length; i < 4; i++){
					addr.push('')
				}
				this.voucher.receiverAddress1 = addr[0]
				this.voucher.receiverAddress2 = addr[1]
				this.voucher.receiverAddress3 = addr[2]
				this.voucher.receiverAddress4 = addr[3]
			},			
			// 国家
			async filterCountry(country) {
				if (country) {
					let countryOptionsCrror = this.countryOptions.filter((options) => {
						// 国家二字码大写，中文,首字母大写,拼音小写对比
						return options.countryCode.indexOf(country.toUpperCase()) != -1 || options.nameChinese.indexOf(country) != -1 || options.nameEnglish.toLowerCase().indexOf(country.toLowerCase()) != -1 || options.firstPinYin.indexOf(country.toUpperCase()) != -1 || string.getPinYinFirstCharacter(options.nameChinese.toLowerCase()).indexOf(country.toLowerCase()) != -1
					})
					countryOptionsCrror.sort((a, b) => {
						let crr_a = a.countryCode == country.toUpperCase() || a.nameChinese == country || a.nameEnglish.toLowerCase() == country.toLowerCase() || a.firstPinYin == country.toUpperCase() || string.getPinYinFirstCharacter(a.nameChinese.toLowerCase()) == country.toLowerCase()
						let crr_b = b.countryCode == country.toUpperCase() || b.nameChinese == country || b.nameEnglish.toLowerCase() == country.toLowerCase() || b.firstPinYin == country.toUpperCase() || string.getPinYinFirstCharacter(b.nameChinese.toLowerCase()) == country.toLowerCase()
						if (crr_a && !crr_b) return -1
						return 1
					})
					this.countryOptionsCrror = countryOptionsCrror
				} else {
					this.countryOptionsCrror = this.countryOptions
				}
			},						
			unrulyGoodsDialogClose(){
				
			},
			detailTableCurrentChanged(val){
				if(!this.skipSetCurrent){
					this.currentDetailRow = val
				}
				this.skipSetCurrent = false
			},
			goodsReportFormCancel(){
				this.$refs.detailTable.setCurrentRow();
				this.currentDetailRow = null        
			},    
			goodsReportFormSave(data){
				let voucherDetail = {...data}
				voucherDetail.wayBillId = this.voucher.wayBillId
				voucherDetail.wayBillNo = this.voucher.wayBillNo
				if(this.currentDetailRow != null){
					this.$set(this.voucher.voucherDetails, this.currentDetailRow.index, voucherDetail)
				}else{
					this.voucher.voucherDetails.push(voucherDetail)
				}
				this.$refs.detailTable.setCurrentRow(); 
				this.currentDetailRow = null
				this.calcTotalPrice()        
			},
			goodsReportFormSaveAs(data){
				let voucherDetail = {...data}
				voucherDetail.wayBillId = this.voucher.wayBillId
				voucherDetail.wayBillNo = this.voucher.wayBillNo
				this.voucher.voucherDetails.push(voucherDetail)
				this.$refs.detailTable.setCurrentRow(); 
				this.currentDetailRow = null
				this.calcTotalPrice()        
			},
			calcTotalPrice(){
				let tp = 0
				for(let voucherDetail of this.voucher.voucherDetails){
					let t = parseFloat(voucherDetail.totalPrice)
					if(!Number.isNaN(t)){
						tp += t
					}
				}
				this.totalPrice = tp
				this.voucher.totalPrice = this.totalPrice
			},
			checkDetailRow(row){
				if(string.isEmpty(row.goodNameEnglish) 
					|| string.isEmpty(row.goodNameChinese) 
					|| string.isEmpty(row.unit)
					|| Number.isNaN(parseInt(row.number)) || (parseInt(row.number) == 0)
					|| Number.isNaN(parseFloat(row.price)) || (parseFloat(row.price) == 0)
					|| Number.isNaN(parseFloat(row.totalPrice))
					|| string.isEmpty(row.hsGoodCode)
					|| string.isEmpty(row.materialEnglish)
					|| string.isEmpty(row.purposeEnglish)){
					return false
				}else{        
					return true
				}
			},
			removeDetail(index, rows) {
				this.$refs.detailTable.setCurrentRow();
				this.currentDetailRow = null          
				rows.splice(index, 1);
				this.calcTotalPrice()
				this.skipSetCurrent = true
			},
			async validateAddressDialogQuery(){
				let tempVoucher = null
				if(this.validateAddressText){
					let address = this.formatValue(this.validateAddressText)
					let addr = this.splitAddress(address); 
					for(let i = addr.length; i < 4; i++){
						addr.push('')
					}
					tempVoucher= {
						receiverAddress1: addr[0],
						receiverAddress2: addr[1],
						receiverAddress3: addr[2],
						receiverAddress4: addr[3]
					}
				}else{
					return
				}
				this.validateAddressResult = ''
				this.validateAddressResultAddress = ''
				let result = await this.$api.validateAddress(tempVoucher)
				if(result.code == 200){
					if(result.rdi=='Commercial'){
						this.validateAddressResult = "商业地址(Commercial)"
					}else
					if(result.rdi=="Residential"){
						this.validateAddressResult = "住宅地址(Residential)"
					}else{
						this.validateAddressResult = result.rdi
					}
					this.validateAddressResultAddress = result.deliveryLines.join("</br>")
				}else{
					this.validateAddressResult = result.errMsg
				}			
			},				
			openForecastSizeDialog(){
				this.$refs.forecastSizeDialog.open()
			},
			forecastSizeDialogClose(){
				console.log(this.voucher.voucherSizes)
			},
			async saveVoucher(){
				if(!this.wayBillNoChecked)return
				if(!this.voucher.wayBillNo){
					this.voucher.wayBillNo = "YB"+parseInt(Math.random()*Math.pow(10,7))
				}
				let address = this.receiverAddress.trim()
				if(address){
					let words = address.replace(/\s+/g, ' ').split(/\s|\n/)
					if(words.length <= 2){
						this.$message.error('收货人地址错误，不能少于等于2个单词!');
						return
					}
				}
				//保存正在输入的产品信息            
				let detail = this.$refs['goodsReportForm'].getGoodsReportData()
				if(detail != null){
					this.goodsReportFormSave(detail)
				}
				try{
					let providerCode = ''
					if((this.branchList != null) && (this.branchList.length == 1)){
						providerCode = this.branchList[0].branchCode
					}
					let voucher = await this.$api.postForecastOrder(providerCode, this.voucher)
					this.voucher = this.voucher0()
					this.receiverAddress = ''
					this.currentDetailRow = null	
					this.$emit('submit')
				}catch(error){
					console.log(error)
					this.$notify.error({
					  title: '错误',
					  message: error
					});                    
					return;
				}							
			}
		}
	}
</script>

<style scoped>
.el-form-item{
    margin-bottom: 0px;
}
.el-form{
    margin-left: 10px;
    margin-right: 10px;
}
.el-select{
  width: 100%;
}
.el-autocomplete{
    width: 100%;
}

.redItem  /deep/ .el-form-item__label{
    color: red;
}

/deep/ .el-dialog__body{
  padding: 5px;
}

/deep/ .el-autocomplete-suggestion{
  width: auto!important;
}	
</style>
